<template>

    <div>

        <h2>Kategórie</h2>
        <div class="categories-list js-categories-list">
            <div class="item"
                 v-for="categoryChildren in categories"
                 :key="categoryChildren.id"
                 :class="{ active: category.id == categoryChildren.id || category.parent_id == categoryChildren.id }"
            >
                <a :href="categoryChildren.detail_url" class="title fa-pseudo">
                    {{ categoryChildren.name }}
                </a>
                <ul v-if="categoryChildren.children">
                    <li v-for="(children, index) in categoryChildren.children"
                        :key="children.id"
                        :class="{ activeSub: category.id == children.id || category.parent_id == children.id }"
                    >
                        <a :href="children.detail_url"
                           class="fa-pseudo">
                            {{ children.name }}
                        </a>

                        <ul v-if="children.children" class="sidebar-subcategories">
                            <li v-for="subchildren in children.children" :key="subchildren.id">
                                <a :href=subchildren.detail_url>
                                    {{ subchildren.name }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        props: {
            categories: {
                type: Array
            },
            category: {
                type: Object
            }
        },

        data() {

            return {
                subCatActive: false
            }
        },

        mounted() {
            let subCatActive = document.querySelector('.activeSub');

            if ( subCatActive )
                subCatActive.parentElement.parentElement.classList.add('active');
        }
    }
</script>
